// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.88.3/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"13045b2d8387ce29c909","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};